import { isNil } from 'lodash';

export default class SessionStorage {
  setUserData(data) {
    const existingData = this.getUserData();
    let userObj = existingData;
    if (!isNil(existingData)) {
      userObj.sub = !isNil(data.sub) ? data.sub : existingData.sub;
      userObj.favoriteplayers = !isNil(data.favoriteplayers)
        ? data.favoriteplayers
        : existingData.favoriteplayers;
      userObj.firstAccess = !isNil(data.firstAccess) ? data.firstAccess : existingData.firstAccess;

      userObj.firstname = !isNil(data.firstname) ? data.firstname : existingData.firstname;
      userObj.lastname = !isNil(data.lastname) ? data.lastname : existingData.lastname;
    } else {
      userObj = {
        sub: data.sub,
        favoriteplayers: data.favoriteplayers,
        firstAccess: data.firstAccess,
        firstname: data.firstname,
        lastname: data.lastname,
      };
    }

    sessionStorage.setItem('userData', JSON.stringify(userObj));
  }

  getUserData() {
    const userObj = sessionStorage.getItem('userData');

    if (!userObj) return undefined;

    return JSON.parse(userObj);
  }

  getFavoritePlayers() {
    const userObj = sessionStorage.getItem('userData');
    if (isNil(userObj)) return null;

    const parsedObj = JSON.parse(userObj);

    if (isNil(parsedObj.favoriteplayers)) return null;

    return parsedObj.favoriteplayers;
  }

  deleteUserData() {
    sessionStorage.removeItem('userData');
  }
}
